import { process } from '../data/siteData'
import ScrollReveal from './ScrollReveal'
import './ProcessTimeline.css'

export default function ProcessTimeline() {
  return (
    <ol className="process-timeline">
      {process.map((step, i) => (
        <ScrollReveal as="li" key={step.step} delay={i * 100} className="process-step">
          <span className="process-number">{step.step}</span>
          <h3>{step.title}</h3>
          <p>{step.text}</p>
        </ScrollReveal>
      ))}
    </ol>
  )
}
